// Images
import wifiDismissLight1x from "@ms/uno-resources/lib/local/images/wifi-dismiss-l-1x.png";
// Components
import { LazyImage } from "../image/LazyImage";
// Styles
import { getClassNames, getStyles } from "./EmptyStateView.styles";
// Utilities
import { ActionButton, ImageFit, useTheme } from "@fluentui/react";
import React from "react";
export var EmptyStateViewType;
(function(EmptyStateViewType) {
    /** Empty state view for no plans */ EmptyStateViewType["NoPlansAvailable"] = "noPlansAvailable";
    /** Empty state view for no plans found */ EmptyStateViewType["NoPlansFound"] = "noPlansFound";
    /** Service error empty state view */ EmptyStateViewType["ServiceError"] = "serviceError";
    /** Empty state view for no portfolios available */ EmptyStateViewType["NoPortfoliosAvailable"] = "noPortfoliosAvailable";
    /** Empty state view for no tasks found for applied filters */ EmptyStateViewType["NoTasksFoundForAppliedFilters"] = "noTasksFoundForAppliedFilters";
})(EmptyStateViewType || (EmptyStateViewType = {}));
/**
 * Renders the empty state view
 */ export function EmptyStateView(props) {
    const theme = useTheme();
    const componentStyles = getStyles(theme);
    const classNames = getClassNames(componentStyles);
    const { root, title, imageContainer, description } = classNames;
    const { emptyStateTitle, emptyStateDescription, emptyStateSvgSrc, actionButtonText, onClickActionButton, actionButtonIconProps, isActionButtonDisabled } = props;
    const titleElement = emptyStateTitle != null ? /*#__PURE__*/ React.createElement("div", {
        className: title
    }, emptyStateTitle) : null;
    const iconElement = emptyStateSvgSrc != null ? /*#__PURE__*/ React.createElement(LazyImage, {
        fetchImage: emptyStateSvgSrc,
        placeholderSrc: wifiDismissLight1x,
        className: imageContainer,
        imageFit: ImageFit.contain
    }) : null;
    const descriptionElement = emptyStateDescription != null ? /*#__PURE__*/ React.createElement("div", {
        className: description
    }, emptyStateDescription) : null;
    const showActionButton = onClickActionButton != null && actionButtonText != null ? /*#__PURE__*/ React.createElement(ActionButton, {
        onClick: onClickActionButton,
        text: actionButtonText,
        styles: componentStyles.subComponentStyles?.actionButton,
        iconProps: actionButtonIconProps,
        disabled: isActionButtonDisabled ?? false
    }) : null;
    return /*#__PURE__*/ React.createElement("div", {
        className: root
    }, titleElement, iconElement, descriptionElement, showActionButton);
}
